// Mirrors Clind::BotOutcomes::ABANDONED_LABEL. A conversation the customer abandoned
// mid-bot is tagged with it just before being auto-resolved, which is what triggers the
// survey — so an NPS inbox with no rule would ask "how likely are you to recommend us" to
// someone who never got an answer. Pre-selected as an exclusion when NPS is first enabled,
// visible and removable. Rename it here and in the Ruby constant together.
export const BOT_ABANDONED_LABEL = 'bot-abandono';

export const surveyTypeFromLegacyFlags = inbox => {
  if (inbox.external_survey_enabled) return 'external';
  if (inbox.csat_survey_enabled) return 'csat';

  return 'none';
};

// `survey_type` is the backend's source of truth, but the legacy `csat_survey_enabled` /
// `external_survey_enabled` booleans are still written by older code paths, so during a
// mixed-version window the enum can be absent (older payload) or stale (an older pod wrote
// only the booleans — on create *and* on update). Reading a stale value renders every mode
// off, and since saving sends `survey_type` back, the next save disables a survey that is
// actually running.
//
// So the enum is trusted only when it agrees with the booleans it mirrors. This is the same
// contradiction check `Inbox#survey_type_should_derive_from_booleans?` performs, and
// deliberately covers every value rather than special-casing 'none'.
export const resolveSurveyType = inbox => {
  if (!inbox) return 'none';
  if (!inbox.survey_type) return surveyTypeFromLegacyFlags(inbox);

  // Only a payload that actually carries the mirrors can contradict the enum. Reading a
  // payload that omits them as "everything off" would recreate the very bug this guards
  // against, from the other side.
  const carriesMirrors =
    'csat_survey_enabled' in inbox || 'external_survey_enabled' in inbox;
  if (!carriesMirrors) return inbox.survey_type;

  const mirrorsAgree =
    Boolean(inbox.csat_survey_enabled) === (inbox.survey_type === 'csat') &&
    Boolean(inbox.external_survey_enabled) ===
      (inbox.survey_type === 'external');

  return mirrorsAgree ? inbox.survey_type : surveyTypeFromLegacyFlags(inbox);
};
